export const client = {
  clientapp: {
    prettyName: 'Client App | Client Apps',
    fields: {
      name: 'Name',
      description: 'Description',
      handle: 'Handle',
      view_id: 'View ID',
      organisation_name: 'Organisation',
    },
    addSetting: 'Add Setting',
    addDefaultSettingKind: 'Add Default Setting Kind',
    addDefaultSettings: 'Add Default Settings',
  },
  clientappsettingkind: {
    prettyName: 'Client App Setting Kind | Client App Setting Kinds',
    fields: {
      client_app: 'Client App',
      name: 'Name',
      description: 'Description',
      handle: 'Handle',
    },
  },
  settingGetFailure: 'Could not get "{key}" from client app settings',
};
